(function () {
  var RESERVE_MINUTES = 15;
  var STORAGE_KEY = 'almara_cart_reserve_deadline';
  var wasOpen = false;

  function startFreshDeadline() {
    var deadline = Date.now() + RESERVE_MINUTES * 60 * 1000;
    sessionStorage.setItem(STORAGE_KEY, String(deadline));
    return deadline;
  }

  function clearDeadline() {
    sessionStorage.removeItem(STORAGE_KEY);
  }

  function format(ms) {
    var totalSeconds = Math.max(0, Math.floor(ms / 1000));
    var minutes = Math.floor(totalSeconds / 60);
    var seconds = totalSeconds % 60;
    return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
  }

  function tick() {
    var el = document.getElementById('CartDrawer-ReserveTimer');
    if (!el) return;

    var cartDrawer = document.querySelector('cart-drawer');
    var isEmpty = cartDrawer && cartDrawer.classList.contains('is-empty');
    if (isEmpty) {
      clearDeadline();
      wasOpen = false;
      return;
    }

    var isOpen = cartDrawer && cartDrawer.classList.contains('active');
    if (!isOpen) {
      wasOpen = false;
      return;
    }

    // Every fresh open of the drawer (closed -> open, the "rising edge")
    // restarts the reservation clock at the full 15:00 — the shopper
    // wants the countdown to reflect "since I opened the cart just now",
    // not a background timer that keeps running across the whole
    // session regardless of whether the drawer was ever looked at.
    if (!wasOpen) {
      startFreshDeadline();
    }
    wasOpen = true;

    var deadline = Number(sessionStorage.getItem(STORAGE_KEY)) || startFreshDeadline();
    var remaining = deadline - Date.now();
    if (remaining <= 0) {
      clearDeadline();
      remaining = 0;
    }
    el.textContent = format(remaining);
  }

  setInterval(tick, 1000);
  document.addEventListener('cart:refresh', tick);
  document.body.addEventListener('cart:build', tick);
  tick();
})();
